import { CmsPageTitleComponentProps } from '@johnlewispartnership/wtr-content-component-library';
import { PAGE_TITLE } from '@johnlewispartnership/wtr-content-component-library/dist/component-library/constants/cmsResourceTypes';
import { useWtrSelector } from 'redux/hooks';
import { getExperienceFragmentLocation } from 'redux/modules/experience-fragments/selectors';

interface UseExperienceFragmentTitleResult {
  title?: string;
  subtitle?: string;
}

/**
 * Retrieves the title and subtitle of a `Title Component` (located in the Waitrose Groceries Components in AEM)
 * @param experienceFragmentKey The key (path) of the fragment experience
 * @param location The `Location Name` of the `Experience Fragment Grid`
 * @returns The found `title` and `subtitle`, if any.
 */
export function useExperienceFragmentTitle(
  experienceFragmentKey: string,
  location = 'title',
): UseExperienceFragmentTitleResult {
  const fragment = useWtrSelector((state: WtrState) =>
    getExperienceFragmentLocation(state, experienceFragmentKey, location),
  );

  const { title, subtitle } =
    (fragment?.[0]?.childComponents?.find(
      component => component.resourceType === PAGE_TITLE,
    ) as CmsPageTitleComponentProps) ?? {};

  return { title, subtitle };
}
